import React from "react";
import { stringToColor } from "../../../utils/stringUtils";
import Avatar from "@mui/material/Avatar";
import { CoreUser } from "@mm-products/java-multima-framework";
import { grey } from "@mui/material/colors";

const AccountAvatar = ({ account }: { account?: CoreUser }) => {
    const firstNameFirstLetter = account?.person?.firstName?.at(0)?.toUpperCase();
    const lastNameFirstLetter = account?.person?.lastName?.at(0)?.toUpperCase();
    const finalLetters =
        !firstNameFirstLetter && !lastNameFirstLetter
            ? account?.username?.at(0)?.toUpperCase() ?? ""
            : (firstNameFirstLetter ?? "") + (lastNameFirstLetter ?? "");
    const colorString = account?.username ?? grey[400];
    return <Avatar sx={{ backgroundColor: stringToColor(colorString) }}>{finalLetters}</Avatar>;
};

export default AccountAvatar;